export default "__VITE_ASSET__BCRsw7rQ__"